export const chargeTypeList = [
  { name: '全部', id: null },
  { name: '服务费', id: 0 }
  // { name: '违约金', id: 1 }
];
export const businessTypeList = [
  { name: '全部', id: null },
  { name: '易资源', id: 1 },
  { name: '询比价', id: 2 }
];
// 状态
export const statusList = [
  { name: '全部', id: null },
  { name: '待支付', id: 0 },
  { name: '支付中', id: 6 },
  { name: '待平台确认', id: 1 },
  { name: '完成', id: 2 },
  // { name: '驳回', id: 3 },
  { name: '支付失败', id: 5 },
  // { name: '作废', id: 4 }
];
export const collectivePurchaseTypeList = [
  { id: null, name: '全部' },
  { id: 1, name: '集采' },
  { id: 0, name: '非集采' },
]